import React from "react";
import {PlainTextarea as Textarea} from "../Textarea/Textarea";
import "./index.css";
import {useEdits} from "../../contexts/edits";

// LinksPanel renders 1-3 single-line inputs for links, styled like BgSelector
// Props:
// - amount: number of link fields to show (1..3)
const LinksPanel = ({amount = 1}) => {
  const {links, links2, links3} = useEdits();

  const values = [
    (links && (links.main ?? "")) || "",
    (links2 && (links2.main ?? "")) || "",
    (links3 && (links3.main ?? "")) || "",
  ];

  const wrappers = ["link", "link2", "link3"]; // used by Textarea to detect type

  return (
    <div className="links-selector" style={{marginTop: 8}}>
      {Array.from({length: Math.min(Math.max(Number(amount) || 1, 1), 3)}, (_, i) => (
        <div key={`link-input-${i}`} className={wrappers[i]} style={{width: "100%"}}>
          <Textarea id={"main"} text={values[i]} inline={true} />
        </div>
      ))}
    </div>
  );
};

export default LinksPanel;


